// extracted by mini-css-extract-plugin
export var pricingCardTitle = "styles-module--pricingCardTitle--3NynX";
export var headerContainer = "styles-module--headerContainer--BOwNn";
export var pricingCardContainer = "styles-module--pricingCardContainer--2xrE_";
export var priceText = "styles-module--priceText--1npF5";
export var detailsText = "styles-module--detailsText--14Cp1";